import { $toast } from "@/utils/useToast";
 
export default {
  install(Vue) {
    Vue.prototype.$notify = $toast;  // ← renombrado a $notify
  },
};


// ══════════════════════════════════════════════════════════════════
// USO EN CUALQUIER COMPONENTE Vue 2
// Reemplaza toastr.success(...) por this.$toast.success(...)
// ══════════════════════════════════════════════════════════════════
 
// ANTES:
// toastr.success(this.$t("booking.statusUpdatedSuccess"));
// toastr.error("No se pudo identificar el registro de pago.");
// toastr.warning("La facturación electrónica no está activada en tu plan.");
 
// DESPUÉS:
// this.$toast.success(this.$t("booking.statusUpdatedSuccess"));
// this.$toast.error("No se pudo identificar el registro de pago.");
// this.$toast.warning("La facturación electrónica no está activada en tu plan.");
 
 
// ══════════════════════════════════════════════════════════════════
// REEMPLAZOS en PayData.vue — busca y reemplaza estas líneas
// ══════════════════════════════════════════════════════════════════
 
/*
  toastr.success(this.$t("booking.statusUpdatedSuccess"))
  → this.$toast.success(this.$t("booking.statusUpdatedSuccess"))
 
  toastr.error(err?.response?.data?.message || this.$t("booking.statusUpdatedError"))
  → this.$toast.error(err?.response?.data?.message || this.$t("booking.statusUpdatedError"))
 
  toastr.warning("La facturación electrónica no está activada en tu plan.")
  → this.$toast.warning("La facturación electrónica no está activada en tu plan.")
 
  toastr.warning(`Completa tus datos de facturación. Faltan: ${...}`)
  → this.$toast.warning(`Completa tus datos de facturación. Faltan: ${...}`)
 
  toastr.success("Link de facturación copiado.")
  → this.$toast.success("Link de facturación copiado.")
 
  toastr.warning("Esta reserva ya tiene factura.")
  → this.$toast.warning("Esta reserva ya tiene factura.")
 
  toastr.error(e?.response?.data?.message || "No se pudo generar el link.")
  → this.$toast.error(e?.response?.data?.message || "No se pudo generar el link.")
 
  toastr.success(this.$t("booking.linkGenerated"))
  → this.$toast.success(this.$t("booking.linkGenerated"))
 
  toastr.success(this.$t("booking.linkRegenerated"))
  → this.$toast.success(this.$t("booking.linkRegenerated"))
 
  toastr.success(this.$t("booking.linkValid"))
  → this.$toast.success(this.$t("booking.linkValid"))
 
  toastr.warning(this.$t("booking.linkPriceZero"))
  → this.$toast.warning(this.$t("booking.linkPriceZero"))
 
  toastr.error(this.$t("booking.linkNoProvider"))
  → this.$toast.error(this.$t("booking.linkNoProvider"))
 
  toastr.error(res.data.message || this.$t("booking.linkValidateError"))
  → this.$toast.error(res.data.message || this.$t("booking.linkValidateError"))
 
  toastr.error(err?.response?.data?.message || this.$t("booking.linkValidateError"))
  → this.$toast.error(err?.response?.data?.message || this.$t("booking.linkValidateError"))
 
  toastr.success(this.$t("booking.copySuccess"))
  → this.$toast.success(this.$t("booking.copySuccess"))
 
  toastr.error("No se pudo cargar el recibo.")
  → this.$toast.error("No se pudo cargar el recibo.")
 
  toastr.error("No se pudo descargar el recibo.")
  → this.$toast.error("No se pudo descargar el recibo.")
 
  toastr.warning("El huésped está fuera de la ventana de 24h de WhatsApp.")
  → this.$toast.warning("El huésped está fuera de la ventana de 24h de WhatsApp.")
 
  toastr.error(body?.message || "Error al enviar el recibo.")
  → this.$toast.error(body?.message || "Error al enviar el recibo.")
 
  toastr.error("No se pudo identificar el registro de pago.")
  → this.$toast.error("No se pudo identificar el registro de pago.")
*/
 